import _axios from "../axios.config";
import { END_POINTS } from "./endPoints";
import { toast } from "react-toastify";
export const AddDealsApis = async (data) => {
  try {
    let response = await _axios.post(END_POINTS.ADD_DEALS, data);

    return {
      success: true,
      data: response?.data,
    };
  } catch (e) {
    console.log("errrrrrrrrrrrrror", e);
    let errorMessage =
      e?.response?.data?.errors[0]?.message ||
      e?.response?.data?.message ||
      "Something went wrong";
    toast.error(errorMessage);
    return {
      success: false,
      error: e,
    };
  }
};

export const EditDealsApis = async (data, id) => {
  try {
    let response = await _axios.put(`${END_POINTS.EDIT_DEALS}${id}`, data);

    return {
      success: true,
      data: response?.data,
    };
  } catch (e) {
    console.log("errrrrrrrrrrrrror", e);
    let errorMessage =
      e?.response?.data?.errors[0]?.message ||
      e?.response?.data?.message ||
      "Something went wrong";
    toast.error(errorMessage);
    return {
      success: false,
      error: e,
    };
  }
};
